import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const SpecialEdu = () => {
  const homeMenu = [
    // { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Special Education"
                breadEnd="Special Education"
                breadMid="Special Education"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-box">
              <p>
                We at Lotus Valley believe that the goal of achieving
                universalization of education is incomplete without inclusive
                and integrated education. The Inclusion department contributes
                as a major catalyst in the field of rehabilitation and
                integration, thus ensuring a barrier free conducive environment
                in the school. Inclusion is both a practice and ideology at
                Lotus Valley.
              </p>
              <p>
                Our school has a Counselling and SEN department which is
                committed to the integration of special needs through improvised
                curriculum and approach as the focus is laid in the holistic
                development of the child's social, emotional, mental and
                cognitive growth. To ensure a synchronized and a collaborative
                approach, the teaching and the non-teaching staff is sensitized
                and trained about the nuances of special needs. The department
                plays gamut of roles to ensure conducive environment in the
                school for our special needs. It is important to make them feel
                respected and connected with their peers. Keeping this in mind
                we offer flexibility to the child and give the important space
                within which she/he can reach her/his maximum potential with
                least alterations in their environment. Thus, working on their
                strengths and setting short-term and long-term goals the school
                aims at a holistic growth of each child. In nutshell, we:
              </p>
              <ul class="admission-list">
                <li>Provide them support to pursue activities of interest.</li>
                <li>Be supportive to any signs of progress.</li>
                <li>Seek parental support and cooperation.</li>
                <li>
                  Sensitize teachers and all supports staff to their needs.
                </li>
                <li>Plan academic and behavioral remedial.</li>
                <li>
                  Assist students during examinations and graded papers as per
                  their academic level.
                </li>
                <li>
                  Ensure their participation in cultural activities, both intra
                  and inter-school.
                </li>
                <li>
                  Synchronize with outside interventions to ensure ongoing
                  progress.
                </li>
              </ul>
              <p>
                The testimony of the amalgamated culture of inclusivity can be
                seen among our students by the fervor with which they celebrate
                International day for person with different abilities. (Debates,
                poster making, collage making, talk by experts, campaigning,
                quiz etc.)
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SpecialEdu;
